import {
  Activity,
  Bone,
  Calendar,
  Check,
  CheckCircle2,
  ChevronDown,
  ClipboardCheck,
  ClipboardList,
  Clock,
  FileBarChart,
  FileText,
  Heart,
  HeartPulse,
  MapPin,
  MessageSquare,
  Microscope,
  Phone,
  RefreshCw,
  ScanFace,
  Search,
  Stethoscope,
  UserPlus,
  Wind,
} from "lucide-react";

const ICONS = {
  activity: Activity,
  bone: Bone,
  calendar: Calendar,
  check: Check,
  checkCircle: CheckCircle2,
  clipboardCheck: ClipboardCheck,
  clipboardList: ClipboardList,
  clock: Clock,
  fileBarChart: FileBarChart,
  fileText: FileText,
  heart: Heart,
  heartPulse: HeartPulse,
  mapPin: MapPin,
  messageSquare: MessageSquare,
  microscope: Microscope,
  phone: Phone,
  refreshCw: RefreshCw,
  scanFace: ScanFace,
  search: Search,
  stethoscope: Stethoscope,
  userPlus: UserPlus,
  wind: Wind,
};

export default function MedicalIcon({ name, size = 20, className = "", strokeWidth = 1.75 }) {
  const Icon = ICONS[name];
  if (!Icon) return null;
  return <Icon size={size} className={className} strokeWidth={strokeWidth} aria-hidden="true" />;
}
